"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UserPosition;
(function (UserPosition) {
    UserPosition["Acquisition"] = "Acquisition";
    UserPosition["Analytics"] = "Analytics";
    UserPosition["ContentCreation"] = "Content management";
    UserPosition["DataScience"] = "Data science";
    UserPosition["Marketing"] = "Marketing";
    UserPosition["Merchandiser"] = "Merchandising";
    UserPosition["Optimisation"] = "Optimisation / Performance";
    UserPosition["ProductManagement"] = "Product management";
    UserPosition["TopManagement"] = "Top management";
    UserPosition["ItAndSecurity"] = "Technical / IT / Security";
    UserPosition["Others"] = "Others";
    UserPosition["Support"] = "Support";
    UserPosition["UiUxDesign"] = "UI / UX Design";
    UserPosition["BusinessIntelligence"] = "Business Intelligence";
    UserPosition["CustomerSuccess"] = "Customer Success";
    UserPosition["CustomerSuccessManager"] = "Customer Success Manager";
    UserPosition["CustomerEnablementManager"] = "Customer Enablement Manager";
    UserPosition["DataAnalyst"] = "Data Analyst";
    UserPosition["Finance"] = "Finance";
    UserPosition["GlobalServices"] = "Global Services";
    UserPosition["Implementation"] = "Implementation";
    UserPosition["Legal"] = "Legal";
    UserPosition["Operations"] = "Operations";
    UserPosition["People"] = "People";
    UserPosition["Product"] = "Product";
    UserPosition["ProductExperienceManager"] = "Product Experience Manager";
    UserPosition["ResearchAndDevelopment"] = "R&D";
    UserPosition["Sales"] = "Sales";
})(UserPosition = exports.UserPosition || (exports.UserPosition = {}));
//# sourceMappingURL=user-position.js.map